import styled from 'styled-components/native'
import StyleVariables from '../../../StyleVariables'

export const ExpiredMessage = styled.Text<{ fontcolor: string }>`
  font-size: 14px;
  color: ${({ fontcolor }) => fontcolor};
  margin-bottom: 16px;
`

export const ExpiredCardRow = styled.View`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`

export const ExpiredCardName = styled.Text<{ fontcolor: string }>`
  font-weight: bold;
  font-size: 14px;
  color: ${({ fontcolor }) => fontcolor};
`

export const ExpiredCardExpiry = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const ExpiredCardExpiryText = styled.Text<{ fontcolor: string }>`
  font-size: 12px;
  color: ${({ fontcolor }) => fontcolor};
  margin-left: 8px;
`
